import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  FormHelperText,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

import { DeleteOutline, FileCopy } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";


//react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { useTranslation } from "react-i18next";
import Constants from "../../../services/Constants";
// import ProductsModal from '../../../services/ProductsModal';
import ProductsLotModal from "../../../services/ProductsLotModal";
// import SourceModal from '../../../services/SourceModal';
// import DatePickerModal from '../../../services/DatePickerModal';
import { cellFocusEditor, dateEditor } from "../../../services/Common";
// import OrderModal from './OrderModalForIssue';

import { fr, enGB } from "date-fns/locale"; // import French and English locale
import { useMutation } from "@tanstack/react-query";
import * as api from "../../../actions/api";

let timeStamp = "";

//errorObject, addProductForm, formData, handleChange, handleCheck, handleReset, handleSubmit, handleUpdate, ManyTableData,ManyJsonSave,handleRDateChange,selectedDate,handleAdd,handleRefech,
const DispenserFormData = (props) => {
  // console.log("props==",props);

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "issue";
  const FacilityId = localStorage.getItem("FacilityId");

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();
  const ReceiveDetailsRefHolder = useRef({ table: null });
  const ReceiveDetailsRef = ReceiveDetailsRefHolder.current;

  const [newBatchRowAdded, setNewBatchRowAdded] = useState(false);

  // console.log("Set r batch");

  const [open, setOpen] = useState(false);
  const [openOrder, setOpenOrder] = useState(false);

  // const [SoureOpen, setSoureOpen] = useState(false);
  // const [DatePickerOpen, setDatePickerOpen] = useState(false);

  const [manyTableData, setManyTableData] = useState([]);
  const [bStockUpdate, setbStockUpdate] = useState(false);

  /*  let IssueToFacility = JSON.parse(localStorage.getItem("IssueToFacility"));
  const IssueToList = IssueToFacility.hasOwnProperty(props.formData.ItemGroupId)?IssueToFacility[props.formData.ItemGroupId]:[];
   */
  // console.log('IssueToList: ', IssueToList);

  const UsersListByFacility = JSON.parse(
    localStorage.getItem("UsersListByFacility"),
  );

  const [currRowId, setCurrRowId] = useState(0);
  const [currFormulation, setCurrFormulation] = useState("");
  // const [currExpiryDate, setCurrExpiryDate] = useState("");
  const [bIsDisable, setbIsEnable] = useState(false);
  const [issuedToFacilityValue, setIssuedToFacilityValue] = useState(null);

  const [IssueToList, setIssuedToFacility] = useState([]);

  /*  const [IssueToList, setIssuedToFacility] = useState([
    {
        "id": 11921,
        "name": "HZ Tanguiéta(Centre confessionnel)",
        "ItemGroupId": 12
    }
  ]); */

  useEffect(() => {
    if (props.formData.ItemGroupId && props.formData.FacilityId) {
      let params = {
        action: "getIssuedToFacilityList",
        menukey: menukey,
        FacilityId: props.formData.FacilityId,
        ItemGroupId: props.formData.ItemGroupId,
      };
      mutate(params);
    }
  }, [props.formData.ItemGroupId, props.formData.FacilityId]);

  /*   useEffect(() => {
  
    setIssuedToFacilityValue(IssueToList[IssueToList.findIndex(IssueTo_List => IssueTo_List.id == props.formData.IssuedToFacility)]);
  
  }, [props.formData.IssuedToFacility]);
 */

  const { mutate } = useMutation(api.getIssuedToFacility, {
    onSuccess: (data) => {
      if (data.status == 200) {
        const list = data.data.datalist || [];
        setIssuedToFacility(list);
        const idx = list.findIndex(
          (row) => row.id == props.formData.IssuedToFacility,
        );
        setIssuedToFacilityValue(idx >= 0 ? list[idx] : null);

        //console.log('OrderToFacility: ', data.data.datalist);
      }
    },
  });

  /* =====Start of Print Excel Many Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintMany = () => {
    let finalUrl =
      EXCEL_EXPORT_URL + "report/esigl_issue_invoice_entry_list_print.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TransactionId=" +
        props.formData.TransactionId +
        "&FacilityId=" +
        FacilityId +
        "&TimeStamp=" +
        Date.now(),
    );
  };

  const ExcelMany = () => {
    let finalUrl =
      EXCEL_EXPORT_URL + "report/esigl_Issue_invoice_entry_list_excel.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TransactionId=" +
        props.formData.TransactionId +
        "&FacilityId=" +
        FacilityId +
        "&TimeStamp=" +
        Date.now(),
    );
  };
  /* =====End of Excel Export Code==== */

  const handleClose = (modalname) => {
    switch (modalname) {
      case "Products":
        setOpen(false);
        break;
      case "ProductsOpen":
        setOpen(true);
        break;

      default:
        break;
    }
  };

  const addProduct = (NonOrderProductData) => {
    console.log("Lot list from modal: ", NonOrderProductData);

    let temNonordata = NonOrderProductData;
    let rows = [];

    let autoId = 0;
    temNonordata.forEach((row, i) => {
      autoId++;
      let newRow = {};
      newRow.ItemNo = row.ItemNo;

      newRow.ItemCode = row.ItemCode;

      newRow.ItemName = row.ItemName;
      newRow.UnitPrice = row.UnitPrice;

      newRow.SourceId = row.SourceId;
      newRow.SourceName = row.SourceName;

      newRow.TransactionItemId = null;
      newRow.OrderRemainingQty = null;

      manyTableData.forEach((rowssss, ij) => {
        if (rowssss.ItemNo == row.ItemNo) {
          newRow.OrderRemainingQty = rowssss.OrderRemainingQty;
          return;
        }
      });

      //   {
      //     "id": 178,
      //     "ItemNo": 178,
      //     "ItemCode": "1P0776",
      //     "ItemName": "Geenius HIV1/2, B/20",
      //     "UnitPrice": null,
      //     "bKeyItem": 0,
      //     "GroupName": "Lab Commodities",
      //     "BatchNo": "FGT98",
      //     "ExpiryDate": null,
      //     "CurrentStockQty": 750,
      //     "SKU": 2,
      //     "SourceId": 12,
      //     "SourceName": "PSLS/FCLI"
      // }

      newRow.CurrentStockQty = row.CurrentStockQty;
      newRow.Quantity = 0;
      newRow.BatchNo = row.BatchNo;
      newRow.ExpiryDate = row.ExpiryDate;

      newRow.OrderId = null;
      newRow.OrderItemId = null;
      newRow.SKU = autoId;
      newRow.id = autoId;
      newRow.LineTotal = 0;
      rows.push(newRow);
    });

    manyTableData.forEach((row, i) => {
      autoId++;
      let newRow = {};
      newRow.ItemNo = row.ItemNo;
      newRow.ItemCode = row.ItemCode;

      newRow.ItemName = row.ItemName;
      newRow.UnitPrice = row.UnitPrice;
      newRow.TransactionItemId = row.TransactionItemId;
      newRow.OrderRemainingQty = row.OrderRemainingQty;
      newRow.CurrentStockQty = row.CurrentStockQty;
      newRow.Quantity = row.Quantity;
      newRow.BatchNo = row.BatchNo;
      newRow.ExpiryDate = row.ExpiryDate;
      newRow.OrderId = row.OrderId;
      newRow.OrderItemId = row.OrderItemId;
      newRow.SKU = autoId;
      newRow.id = autoId;
      newRow.LineTotal = row.Quantity * row.UnitPrice;

      newRow.SourceId = row.SourceId;
      newRow.SourceName = row.SourceName;

      rows.push(newRow);
    });

    setManyTableData(rows);
    props.handleAdd(rows);
    handleClose("Products");
  };

  const ReceiveDetailsColumns = [
    { title: "TransactionItemId", field: "TransactionItemId", visible: false },
    { title: "id", field: "id", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      width: 70,
      formatter: "rownum",
      hozAlign: "center",
      headerHozAlign: "center",
      headerSort: false,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerSort: false,
      headerHozAlign: "center",
      hozAlign: "center",
      width: 80,
      formatter: reactFormatter(
        <ActionButton
        /* insertBatchInUpdatedDetailGridData={props.insertBatchInUpdatedDetailGridData} */
        />,
      ),
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "ItemCode",
      width: 130,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "ItemName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Quantity Ordered"]),
      field: "OrderRemainingQty",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Current Stock"]),
      field: "CurrentStockQty",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Quantity Issued"]),
      field: "Quantity",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      validator: [
        "integer",
        "min:0",
        function (cell, value, parameters) {
          if (value == "") return true;
          // if (!props.isPositive) return true;
          const balance = cell.getRow().getCell("CurrentStockQty").getValue();
          const validstatus = parseInt(value) <= parseInt(balance);
          return validstatus;
        },
      ],
      cssClass: "tabluator-column-editable",
      editor: props.bStockUpdate == 0 ? cellFocusEditor : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        const pricecell = currow.getCell("LineTotal");
        const totprice = rowdata.UnitPrice * curcellval;
        pricecell.setValue(totprice);
      },
    }, //
    {
      title: t(DispensingLanguage[lan][menukey]["Lot No"]),
      field: "BatchNo",
      width: 100,
      // cssClass: "tabluator-column-editable text-field-editable",
      // editor: props.bStockUpdate == 0 ? cellFocusEditor: '',
      // cellEdited: function (cell) {
      //   const curcellval = cell.getValue();
      //   const currow = cell.getRow();
      //   const rowdata = currow.getData();
      // }
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Expiry Date"]),
      field: "ExpiryDate",
      width: 100,
      // cssClass: "tabluator-column-editable text-field-editable",
      // editor: props.bStockUpdate == 0 ? cellFocusEditor: '',
      // cellEdited: function (cell) {

      //   const curcellval = cell.getValue();
      //   const currow = cell.getRow();
      //   const rowdata = currow.getData();
      // }
    },
    // {
    //   title: "",
    //   headerSort: false,
    //   field: "custom",
    //   hozAlign: "center",
    //   width: 8,
    //   formatter: reactFormatter(<ShowDatePickerPopup />),
    // },

    {
      title: "SourceId",
      field: "SourceId",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Source"]),
      field: "SourceName",
      width: 120,
    },

    // {
    //   title: "",
    //   headerSort: false,
    //   field: "custom",
    //   hozAlign: "center",
    //   width: 8,
    //   formatter: reactFormatter(<ShowSourcePopup />),
    // },

    {
      title: t(DispensingLanguage[lan][menukey]["Unit Price (CFA)"]),
      field: "UnitPrice",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      // validator:["min:0"],
      // cssClass: "tabluator-column-editable",
      // editor: props.bStockUpdate == 0 ? cellFocusEditor: '',
      // cellEdited: function (cell) {
      // const curcellval = cell.getValue();
      // const currow = cell.getRow();
      // const rowdata = currow.getData();
      // const pricecell = currow.getCell("LineTotal");
      // const totprice = rowdata.Quantity * curcellval;
      // pricecell.setValue(totprice);

      // }
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Line Total (CFA)"]),
      field: "LineTotal",
      width: "10%",
      formatter: "money",
      hozAlign: "right",
      headerHozAlign: "right",
      bottomCalc: "sum",
      bottomCalcFormatter: "money",
    },
  ];

  const onPostBtnClick = () => {
    setbStockUpdate(true);
    props.handlePost();
  };

  const onSaveUpdateBtnClick = () => {
    if (props.isSubmitting) return;
    props.setUpdatedDetailsGridDataHandler(ReceiveDetailsRef.table.getData());
    //  props.handleUpdate();
  };

  const deleteReceiveInv = (data) => {
    let newarray = manyTableData.filter((element) => element !== data);
    setManyTableData(newarray);
    props.deleteReceiveInv(data);
  };

  const CopyBatch = () => {
    props.handleAdd(manyTableData);
  };

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    // const goToDetails = () => {

    //   let rowobj = props.cell._cell.row.data;
    //   console.log("I copied this line", rowobj);
    //   timeStamp = Math.round(new Date().getTime() / 100);

    //   setManyTableData((prevRows) => {

    //     const tmpPrevRows = [...prevRows];

    //     let setRposition = tmpPrevRows.findIndex((o) => o.SKU ==rowobj.SKU);
    //     console.log("Rposition",setRposition);

    //     const obj = { ...rowobj };

    //     obj.id = timeStamp;
    //     obj.TransactionItemId = "";
    //     obj.ExpiryDate = "";
    //     obj.BatchNo = "";
    //     obj.Quantity = 0;
    //     obj.SKU = Date.now();

    //     console.log("new object added in grid:", obj);
    //     tmpPrevRows.splice(setRposition+1, 0, obj)

    //     return tmpPrevRows;
    //   });

    //   CopyBatch();
    //   setNewBatchRowAdded((prevNewBatchRowAdded) => !prevNewBatchRowAdded);

    // };

    const cellValue = props.cell._cell.value || "Edit | Show";
    // console.log('props props props',rowData.OrderItemId);
    if (bStockUpdate == 0 && !rowData.OrderItemId)
      return (
        <>
          {/* <FileCopy
          onClick={() => {
            if (!bStockUpdate) goToDetails(rowData);
          }}
        /> */}

          <DeleteOutline
            onClick={() => {
              if (!bStockUpdate) deleteReceiveInv(rowData);
            }}
          />
        </>
      );
    else return <></>;
  }

  useEffect(() => {
    if (props.bFirst) {
      setManyTableData(props.ManyTableData);
    }

    setbStockUpdate(props.bStockUpdate);
  }, [props.ManyTableData, props.bStockUpdate]); //

  useEffect(() => {
    if (ReceiveDetailsRef.table != null && timeStamp != "") {
      // console.log("Many table",ReceiveDetailsRef.table);
      // console.log("Many table 12222222222");

      ReceiveDetailsRef.table.scrollToRow(timeStamp, "center", true);
      ReceiveDetailsRef.table.selectRow(timeStamp);
    }
  }, [newBatchRowAdded]);

  const handleReset = () => {
    setManyTableData([]);
    props.handleReset();
  };

  const changeissuedToFacilityValue = (val) => {
    setIssuedToFacilityValue(val);

    if (val != null) {
      props.formData.IssuedToFacility = val.id;
    } else {
      props.formData.IssuedToFacility = "";
    }

    props.handleChangeissuedToFacilityProps(val);
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {DispensingLanguage[lan][menukey]["Issue - Add/Edit"]}
                </div>

                <div className="float-end sw_btn_control">
                  {props.addProductForm ? (
                    <Grid item xs={12} className="mt-4 text-center">
                      <div className="float-end sw_btn_control">
                        <Button
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => handleReset()}
                          // onClick={() => props.handleReset()}
                        >
                          {DispensingLanguage[lan][menukey]["Reset"]}
                        </Button>
                        <Button
                          className="me-2"
                          variant="contained"
                          color="primary"
                          disabled={!!props.isSubmitting}
                          onClick={onSaveUpdateBtnClick} //() => props.handleSubmit()
                        >
                          {DispensingLanguage[lan][menukey]["Save"]}
                        </Button>
                        <Button
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => props.history.push("/issue")}
                        >
                          {DispensingLanguage[lan][menukey]["Back to List"]}
                        </Button>
                      </div>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className="mt-2 text-center">
                      <Button
                        disabled={
                          !!props.bStockUpdate || !!props.isSubmitting
                        }
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={onSaveUpdateBtnClick}
                      >
                        {DispensingLanguage[lan][menukey]["update"]}
                      </Button>
                      <Button
                        disabled={
                          !!props.bStockUpdate || !!props.isSubmitting
                        }
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={onPostBtnClick}
                      >
                        {DispensingLanguage[lan][menukey]["post"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/issue")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className="me-2 sw_icons"
                        onClick={() => PrintMany()}
                      >
                        <i className="fas fa-print"></i>
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className="me-2 sw_icons"
                        onClick={() => ExcelMany()}
                      >
                        <i className="far fa-file-excel"></i>
                      </Button>
                    </Grid>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <Grid container spacing={3} className="mb-3">
          <Grid item xs={3} sm={3}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
              <DatePicker
                disabled={!!props.bStockUpdate}
                //disableToolbar
                label={DispensingLanguage[lan][menukey]["Issue Date"]}
                value={props.formData.TransactionDate || props.selectedDate}
                inputFormat="dd/MM/yyyy"
                onChange={(e) => props.handleRDateChange(e, "TransactionDate")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      value: params.inputProps?.value ?? "",
                    }}
                    variant="standard"
                    required
                    error={!!props.errorObject.TransactionDate}
                    helperText={props.errorObject.TransactionDate}
                    className={classes.fullWidth}
                    id="TransactionDate"
                    name="TransactionDate"
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              disabled={true /*bStockUpdate*/}
              error={!!props.errorObject.TransactionNo}
              helperText={props.errorObject.TransactionNo}
              required
              id="TransactionNo"
              name="TransactionNo"
              label={DispensingLanguage[lan][menukey]["Issue Invoice No"]}
              // value={formData.FirstName || "Mahmudul"}
              value={(props.formData.TransactionNo ?? props.generatedInvoiceNo) ?? ""}
              fullWidth
              autoComplete="family-name"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl className={classes.fullWidth}>
              <Autocomplete
                // disabled={demanderactive}
                disabled={!!props.bStockUpdate}
                autoHighlight
                id="IssuedToFacility"
                options={IssueToList}
                onChange={(event, value) => changeissuedToFacilityValue(value)}
                getOptionLabel={(option) => option?.name ?? ""}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                value={issuedToFacilityValue}
                renderOption={(props, option) => (
                  <li {...props} key={option.id ?? option.name}>
                    <Typography className="sw_fontSize">
                      {option.name}
                    </Typography>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      value: params.inputProps?.value ?? "",
                    }}
                    label={DispensingLanguage[lan][menukey]["Recipient"]}
                    variant="standard"
                    error={!!props.errorObject.IssuedToFacility}
                    helperText={props.errorObject.IssuedToFacility}
                    required
                    id="IssuedToFacility"
                    name="IssuedToFacility"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              disabled={true /*bStockUpdate*/}
              error={!!props.errorObject.OrderNo}
              helperText={props.errorObject.OrderNo}
              id="OrderNo"
              name="OrderNo"
              label={DispensingLanguage[lan][menukey]["Order No"]}
              // value={formData.FirstName || "Mahmudul"}
              value={props.formData.OrderNo ?? ""}
              fullWidth
              autoComplete="family-name"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Prepared By"]} *
              </InputLabel>
              <Select
                error={!!props.errorObject.PreparedBy}
                labelId="demo-simple-select-helper-label"
                id="PreparedBy"
                name="PreparedBy"
                value={props.formData.PreparedBy ?? ""}
                fullWidth
                onChange={(e) => props.handleChange(e)}
                disabled={!!(props.IsCompleted || props.bStockUpdate)}
                label={`${DispensingLanguage[lan][menukey]["Prepared By"]} *`}
              >
                {UsersListByFacility.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={!!props.errorObject.PreparedBy}>
                {props.errorObject.PreparedBy}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Approved By"]} *
              </InputLabel>
              <Select
                error={!!props.errorObject.ApprovedBy}
                labelId="demo-simple-select-helper-label"
                id="ApprovedBy"
                name="ApprovedBy"
                value={props.formData.ApprovedBy ?? ""}
                fullWidth
                onChange={(e) => props.handleChange(e)}
                disabled={!!(props.IsCompleted || props.bStockUpdate)}
                label={`${DispensingLanguage[lan][menukey]["Approved By"]} *`}
              >
                {UsersListByFacility.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={!!props.errorObject.ApprovedBy}>
                {props.errorObject.ApprovedBy}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              id="FacilityId"
              name="FacilityId"
              label="FacilityId"
              value={props.formData.FacilityId ?? ""}
              fullWidth
              hidden
              autoComplete="family-name"
            />
            <TextField
              variant="standard"
              id="TransactionId"
              name="TransactionId"
              label="TransactionId"
              value={props.formData.TransactionId ?? ""}
              fullWidth
              hidden
              autoComplete="family-name"
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={12}>
                    <div className="float-end sw_btn_control">
                      <Button
                        disabled={!!props.bStockUpdate}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleClose("ProductsOpen")}
                      >
                        {DispensingLanguage[lan][menukey]["SELECT PRODUCT"]}
                      </Button>
                    </div>
                    <ProductsLotModal
                      handleClose={handleClose}
                      open={open}
                      FacilityId={FacilityId}
                      addProduct={addProduct}
                      {...props}
                    />
                  </Grid>
                </Grid>
                <ReactTabulator
                  onRef={(r) => {
                    ReceiveDetailsRef.table = r.current;
                  }}
                  columns={ReceiveDetailsColumns}
                  data={manyTableData}
                  height="350px"
                  layout={"fitColumns"}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default DispenserFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
